import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ExcelService } from '../../../../../service/excel.service';
import { ApiService } from 'src/app/service/api.service';
import { CoreService } from 'src/app/service/core.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-sales-ratio-rep',
  templateUrl: './sales-ratio-rep.component.html',
  styleUrls: ['./sales-ratio-rep.component.css']
})
export class SalesRatioRepComponent implements OnInit {
  fileName = 'stock_to_sales_ratio_report.xlsx';

  salesSum: any;
  pageLoadingImg: boolean;
  repDate: any;
  branch_all: any;
  userType: any;
  cur_lang: string;
  curpage: any;
  lastpage: any;
  products: any[];
  pgstart: boolean;
  pgend: boolean;
  pageFrom: any;
  total_avail_qty: any;
  total_sold_qty: any;
  total_sale_ratio: any;
  period_type: any;
  qty_prchamnt: any;
  purch_rate: string;
  exportLoader: boolean;
  ExpsalesSum: any;
  branch_address: any;
  branch_display_name: any;
  branch_display_code: any;
  country_dec: any;

  constructor(private apiService: ApiService, private coreService: CoreService, private translate: TranslateService, private excelService: ExcelService) { }

  periodTypes = [
    { id: 't', name: 'Today' },
    { id: 'ld', name: 'Last Day' },
    { id: 'lw', name: 'Last week' },
    { id: 'lm', name: 'Last Month' },
    { id: 'ly', name: 'Last Year' },
    { id: 'c', name: 'Custom Date' },
    { id: '', name: 'All' }

  ];

  qty_prchamnt_type = [
    { id: 0, name: 'Qty' },
    { id: 1, name: 'Purchase Amount' }
  ];

  purch_rate_option = [
    { id: 'bs_avg_prate', name: 'Avg Purch.Rate' },
    { id: 'bs_prate', name: 'Last Purch.Rate' }
  ];

  ngOnInit() {
    this.cur_lang = sessionStorage.getItem("baseLang");
    this.branch_address = this.coreService.getUserData('branch_address');
    this.branch_display_name = this.coreService.getUserData('branch_disp_name');
    this.branch_display_code = this.coreService.getUserData('branch_code');
    this.country_dec = this.coreService.setDecimalLength();

    this.apiService.cur_lang.subscribe(value => {
      this.cur_lang = value;
    })
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.langChange();
    });
    this.pageLoadingImg = true;
    this.period_type = 'ld';
    this.qty_prchamnt = 0;
    this.purch_rate = 'bs_prate';
    let searchval = new FormData();
    searchval.append('period_type', 'ld');
    this.apiService.salesRatioRep(searchval, 1).subscribe((res: any) => {
      this.pageLoadingImg = false;
      this.repDate = res['data'].Date;
      this.salesSum = res['data']['data'];
      this.curpage = res['data']['current_page'];
      this.lastpage = res['data']['last_page'];
      this.pageFrom = res['data']['from'];
      this.total_avail_qty = res['data'].total_avail_qty;
      this.total_sold_qty = res['data'].total_sold_qty;
      this.total_sale_ratio = res['data'].total_sale_ratio;

      this.pgEnd(this.curpage, this.lastpage);
      this.pgStart(this.curpage);

    });

    this.userType = this.coreService.getUserData('user_type');
  }

  langChange() {
    this.translate.get(['Common.today', 'Common.last_day', 'Common.last_week', 'Common.last_maonth', 'Common.last_yr', 'Common.cust_date', 'Common.all', 'Table.qty', 'HOME.purchase_Amount', 'Common.average_purchase_rate', 'Common.Last_Purchase_Rate']).subscribe((res: string) => {

      this.periodTypes = [

        { id: 't', name: res['Common.today'] },
        { id: 'ld', name: res['Common.last_day'] },
        { id: 'lw', name: res['Common.last_week'] },
        { id: 'lm', name: res['Common.last_maonth'] },
        { id: 'ly', name: res['Common.last_yr'] },
        { id: 'c', name: res['Common.cust_date'] },
        { id: '', name: res['Common.all'] }

      ];

      this.qty_prchamnt_type = [
        { id: 0, name: res['Table.qty'] },
        { id: 1, name: res['HOME.purchase_Amount'] }
      ];

      this.purch_rate_option = [
        { id: 'bs_avg_prate', name: res['Common.average_purchase_rate'] },
        { id: 'bs_prate', name: res['Common.Last_Purchase_Rate'] }
      ];
    });

  }

  // search branch
  searchBranch(search: string) {
    let searchval = new FormData();
    searchval.append("branch_name", search);
    this.apiService.getBranchByName(searchval).subscribe((res) => {
      this.branch_all = res['data'];
    });
  }

  // search product
  selectProd(name: string) {

    const searchval = new FormData();
    if (this.cur_lang != undefined && this.cur_lang != null && this.cur_lang != 'English') {
      searchval.append('alias_search', '1');
    }
    searchval.append('prod_name', name);
    this.apiService.getProdByName(searchval).subscribe((res) => {
      this.products = res.data;
    });
  }

  pageNext(formdata: { value: any; }, pageno: any) {
    formdata.value.export = '';

    this.pageLoadingImg = true;
    if (formdata.value.period_type === 'c') {
      formdata.value.date1 = (formdata.value.date1) ? this.apiService.formatDate(formdata.value.date1) : formdata.value.date1;
      formdata.value.date2 = (formdata.value.date2) ? this.apiService.formatDate(formdata.value.date2) : formdata.value.date2;
    }

    this.salesSum = [];

    this.apiService.salesRatioRep(formdata.value, pageno).subscribe((res: any) => {
      this.pageLoadingImg = false;
      this.repDate = res['data'].Date;
      this.salesSum = res['data']['data'];
      this.curpage = res['data']['current_page'];
      this.lastpage = res['data']['last_page'];
      this.pageFrom = res['data']['from'];
      this.total_avail_qty = res['data'].total_avail_qty;
      this.total_sold_qty = res['data'].total_sold_qty;
      this.total_sale_ratio = res['data'].total_sale_ratio;

      this.pgEnd(this.curpage, this.lastpage);
      this.pgStart(this.curpage);

    });

  }

  pgEnd(curr, end) {
    if (curr == end)
      this.pgend = true;
    else
      this.pgend = false;

  }

  pgStart(curr) {
    if (curr == 1)
      this.pgstart = true;
    else
      this.pgstart = false;
  }

  // Excel Export
  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('export-group');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { raw: true });

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
    this.exportLoader = false;

  }

  exportEXCL(formdata: { value: any; }, pageno = 1) {
    formdata.value.export = 'export';
    if (formdata.value.period_type === 'c') {
      formdata.value.date1 = (formdata.value.date1) ? this.apiService.formatDate(formdata.value.date1) : formdata.value.date1;
      formdata.value.date2 = (formdata.value.date2) ? this.apiService.formatDate(formdata.value.date2) : formdata.value.date2;
    }
    this.exportLoader = true;

    this.apiService.salesRatioRep(formdata.value, pageno).subscribe((res: any) => {
      this.repDate = res['data'].Date;
      this.ExpsalesSum = res['data']['data'];
      this.total_avail_qty = res['data'].total_avail_qty;
      this.total_sold_qty = res['data'].total_sold_qty;
      this.total_sale_ratio = res['data'].total_sale_ratio;

      setTimeout(() => {
        this.exportexcel();
      }, 3000);

    });

  }

  // PDF Download
  generatePdf(formdata: { value: any; }) {

    if (formdata.value.period_type === 'c') {
      formdata.value.date1 = (formdata.value.date1) ? this.apiService.formatDate(formdata.value.date1) : formdata.value.date1;
      formdata.value.date2 = (formdata.value.date2) ? this.apiService.formatDate(formdata.value.date2) : formdata.value.date2;
    }
    this.exportLoader = true;

    // debugger;
    formdata.value.export = 'export';


    this.apiService.salesRatioRep(formdata.value, 1).subscribe((res: any) => {
      this.repDate = res['data'].Date;
      this.ExpsalesSum = res['data']['data'];
      this.total_avail_qty = res['data'].total_avail_qty;
      this.total_sold_qty = res['data'].total_sold_qty;
      this.total_sale_ratio = res['data'].total_sale_ratio;

      const total_avail_qty_label = this.qty_prchamnt == 1
        ? `${this.translate.instant('HOME.total')} ${this.translate.instant('HOME.purch_price_of_avail_stock')}`
        : `${this.translate.instant('HOME.total')} ${this.translate.instant('HOME.available_stock')}`;

      const total_sold_qty_label = this.qty_prchamnt == 1
        ? `${this.translate.instant('HOME.total')} ${this.translate.instant('HOME.purch_price_of_sold_prdct')}`
        : `${this.translate.instant('HOME.total')} ${this.translate.instant('Common.Sold_Qty')}`;

      const avail_qty = this.qty_prchamnt == 1
        ? this.translate.instant('HOME.purch_price_of_avail_stock')
        : `${this.translate.instant('HOME.available_stock')} ${this.translate.instant('HOME.qty')}`;

      const sold_qty = this.qty_prchamnt == 1
        ? this.translate.instant('HOME.purch_price_of_sold_prdct')
        : this.translate.instant('Common.Sold_Qty');


      const heads = [
        this.translate.instant('HOME.sl_no'),
        this.translate.instant('Table.barcode'),
        this.translate.instant('Common.prd_name'),
        avail_qty,
        sold_qty,
        'Ratio'
      ];

      const lblXPos = 10;
      const headerHeight = 15;
      const valueXPos = 70;
      const data = [];

      this.ExpsalesSum.forEach((item, i) => {
        const arr = [
          i + 1,
          item.prd_barcode,
          item.prd_name,
          (item.avail_qty).toFixed(2),
          (item.sold_qty).toFixed(2)

        ]

        if (item.sale_ratio == 0) {
          arr.splice(5, 0, '∞')
        }

        if (item.sale_ratio != 0) {
          arr.splice(5, 0, (item.sale_ratio).toFixed(2))
        }

        data.push(arr)
      })

      let doc = this.excelService.getPdfObj();

      var addressLines = this.branch_address.split('\r\n');
      var addressText = addressLines.join(', ');

      doc.setFont('Amiri');
      doc.setFontSize(12);
      doc.text(this.branch_display_name + ' ' + '(' + this.branch_display_code + ')', 70, headerHeight - 2);

      doc.setFont('Amiri');
      doc.setFontSize(9);
      doc.text(addressText, 71, headerHeight + 2);

      if (this.repDate) {
        doc.setFontSize(10);
        doc.text(`${this.translate.instant('Common.Duration')}`, lblXPos, headerHeight + 10);
        doc.setFontSize(10);
        doc.text(':  ' + this.repDate.date1 + '   to   ' + this.repDate.date2, valueXPos, headerHeight + 10);
      }

      doc.setFontSize(10);
      doc.text(`${this.translate.instant('HOME.REPORT')}`, lblXPos, headerHeight + 15);
      doc.setFontSize(10);
      doc.text(':  ' + `${this.translate.instant('Common.stock_to_sales_ratio_report')}`, valueXPos, headerHeight + 15);

      doc.setFontSize(10);
      doc.text(total_avail_qty_label, lblXPos, headerHeight + 20);
      doc.setFontSize(10);
      doc.text(':  ' + (this.total_avail_qty).toFixed(2), valueXPos, headerHeight + 20);

      doc.setFontSize(10);
      doc.text(total_sold_qty_label, lblXPos, headerHeight + 25);
      doc.setFontSize(10);
      doc.text(':  ' + (this.total_sold_qty).toFixed(2), valueXPos, headerHeight + 25);

      doc.setFontSize(10);
      doc.text(`${this.translate.instant('HOME.total')} ${this.translate.instant('Table.sales_ratio')}`, lblXPos, headerHeight + 30);
      doc.setFontSize(10);

      if (this.total_sale_ratio == 0) {
        doc.text(':  ' + '∞', valueXPos, headerHeight + 30);
      } else {
        doc.text(':  ' + (this.total_sale_ratio).toFixed(2), valueXPos, headerHeight + 30);
      }

      if (this.qty_prchamnt == 1) {
        doc.setFontSize(10);
        doc.setTextColor(255, 0, 0);

        if (this.purch_rate == 'bs_prate') {
          doc.text(this.translate.instant('Common.Last_Purchase_Rate'), lblXPos, headerHeight + 35);
        } else {
          doc.text(this.translate.instant('Common.average_purchase_rate'), lblXPos, headerHeight + 35);
        }
      }

      doc = this.excelService.addTableToPdf(doc, headerHeight + 40, lblXPos, heads, data, null);

      doc.save(`Stock to Sales Ratio Report.pdf`);

      this.exportLoader = false;

    });

  }

  // Preview Print
  startPrint(formdata: { value: any; }, pageno = 1) {
    formdata.value.export = 'export';
    if (formdata.value.period_type === 'c') {
      formdata.value.date1 = (formdata.value.date1) ? this.apiService.formatDate(formdata.value.date1) : formdata.value.date1;
      formdata.value.date2 = (formdata.value.date2) ? this.apiService.formatDate(formdata.value.date2) : formdata.value.date2;
    }
    this.exportLoader = true;

    this.apiService.salesRatioRep(formdata.value, pageno).subscribe((res: any) => {
      this.repDate = res['data'].Date;
      this.ExpsalesSum = res['data']['data'];
      this.total_avail_qty = res['data'].total_avail_qty;
      this.total_sold_qty = res['data'].total_sold_qty;
      this.total_sale_ratio = res['data'].total_sale_ratio;

      this.exportLoader = false;
      setTimeout(() => {
        $('#printButton').click();
      }, 500);

    });
  }

}
